export default "__VITE_ASSET__3b4ccabd__"